export class CalculateReimbursementCommand {
    verificationId: string = '';

    constructor(verificationId: string) {
        this.verificationId = verificationId;
    }
}

export interface ProcedureReimbursementResult {
    priority: number;
    code: string;
    procedureReimbursement: number;
    implantReimbursement: number;
    totalReimbursement: number;
}

export interface CalculateReimbursementResponse {
    verificationId: string;
    success: boolean;
    errorMessage?: string;
    procedures: ProcedureReimbursementResult[];
}
